import { render, staticRenderFns } from "./serive.vue?vue&type=template&id=99c1e27e&scoped=true&"
import script from "./serive.vue?vue&type=script&lang=js&"
export * from "./serive.vue?vue&type=script&lang=js&"
import style0 from "./serive.vue?vue&type=style&index=0&id=99c1e27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c1e27e",
  null
  
)

export default component.exports